































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import headerQaMock from '@/store/mock/header.qa.mock.js';
import lang2d from '../../../../utils/lang/lang-2d.js';

@Component({
    components: {}
})
export default class headerQA extends Vue{
    lang:any = lang2d;
    // @Prop()
    // data: any;
    queryList = [];
    scrollTimer: any;
    count: number = 0;
    dataType: any;
    // 实时计算上移的高度，为什么要实时计算？如果采用count * 单个高度，后面的上移距离有问题，由于百分比的关系，实际每个item高度不是完全一样的
    transH = 0;

    isCorrectDataType () {
        let cur_time = new Date().getHours();
        if (cur_time >= 9 && cur_time < 11) {
            return this.dataType === '0911'
        } else if (cur_time >= 11 && cur_time < 14) {
            return this.dataType === '1114';
        } else if (cur_time >= 14 && cur_time < 18) {
            return this.dataType === '1418';
        } else {
            return this.dataType === '1809';
        }
    }

    getDateType() {
        let cur_time = new Date().getHours();
        if (cur_time >= 9 && cur_time < 11) {
            this.queryList = headerQaMock['0911'];
            this.dataType = '0911';
        } else if (cur_time >= 11 && cur_time < 14) {
            this.queryList = headerQaMock['1114'];
            this.dataType = '1114';
        } else if (cur_time >= 14 && cur_time < 18) {
            this.queryList = headerQaMock['1418'];
            this.dataType = '1418'
        } else {
            this.queryList = headerQaMock['1809']
            this.dataType = '1809';
        }
        this.reset();
    }

    reset() {
        this.count = 0;
        this.transH = 0;
        clearTimeout(this.scrollTimer);
        this.scrollPostion();
    }

    scrollPostion() {
        if (!this.isCorrectDataType()) {
            this.getDateType();
            return;
        }

        if (!this.queryList || !this.queryList.length) {
            return;
        }
        this.scrollTimer = setTimeout(()=> {
            this.translatePosition();
        }, 2500);
    }

    translatePosition() {
        let queryQ = document.getElementById('query-Q');
        let queryA = document.getElementById('query-A');
        let loopH = queryQ.children[this.count].clientHeight;
        let total = queryQ.children.length;
        this.count++;
        this.transH += loopH;
        if (this.count >= total ) {
            this.count = 0;
            this.transH = 0;
        }

        if(this.count === 0 ) {
            queryQ.style.transform = 'translateY(0)';
            queryA.style.transform = 'translateY(0)';
            queryQ.className = 'loop';
            queryA.className = 'loop';
        } else {
            queryQ.style.transform = `translateY(-${this.transH}px)`;
            queryQ.className = 'loop transition-scroll-top';
            queryA.style.transform = `translateY(-${this.transH}px)`;
            queryA.className = 'loop transition-scroll-bottom';
        }
        this.scrollPostion();
    }
    beforeDestroy() {
        clearTimeout(this.scrollTimer);
    }

    mounted() {
        this.getDateType();
    }


};
